import { useTranslate } from '@refinedev/core';
import { Select } from 'antd';
import { useMemo } from 'react';
import { ALL_CATEGORIES, categoryOptions } from './categoryFilter';

/**
 * P039 · the worksheet Category dropdown — small and dumb. One component for the Assign drawer, the pathway
 * step's Target and the backoffice library table. The caller owns the value (opens on "all" every time —
 * nothing is remembered) and the list the counts are made from (the list the language switch produced).
 * i18n: worksheets.picker.category / .allCategories / .optionCount; worksheets.category.*.
 */
type Props = {
  templates: readonly { category: string }[];
  value: string | undefined;
  onChange: (category: string) => void;
  'data-testid': string;
  style?: React.CSSProperties;
};

export const WorksheetCategorySelect = ({ templates, value, onChange, style, ...rest }: Props) => {
  const t = useTranslate();
  const options = useMemo(
    () => categoryOptions(templates, (key, o) => t(key, o as never)),
    [templates, t],
  );
  return (
    <Select
      style={{ width: '100%', ...style }}
      value={value ?? ALL_CATEGORIES}
      onChange={onChange}
      options={options}
      aria-label={t('worksheets.picker.category')}
      data-testid={rest['data-testid']}
    />
  );
};
